import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import ImageItem from '../ImageItem';
import QuoteCarousel from '../QuoteCarousel';
import { DownloadCard, DownloadCardContent } from '../DownloadComponents';

import style from './AcceptTermsPageContent.module.scss';
import CarouselStandardNews from '../CarouselStandardNews';
import { useWindowSize } from '@react-hook/window-size/throttled';

const CaseStudyCard = ({ title, cta, image, publishingDate, type }) => {
    const { SmartLink } = require('../SmartLink');
    const hasImage = image && image.url !== '';

    return (
        <div className={style.caseStudyCard}>
            <div className={[style.caseStudyContent, !hasImage ? style.noImage : null].join(' ')}>
                {hasImage && (
                    <div className={style.caseStudyWrapper}>
                        <div className={style.caseStudyImage}>
                            <img src={image.url} alt={image.alt} />
                        </div>
                    </div>
                )}
                <div className={[style.caseStudyWrapper, style.right].join(' ')}>
                    <div className={style.caseStudyHeader}>
                        {type && <div className={[style.caseStudyType, !hasImage ? style.orange : ''].join(' ')}>{type}</div>}
                        {publishingDate && <div className={style.caseStudyDate}>{publishingDate}</div>}
                    </div>
                    <div className={style.caseStudyTitle}>
                        <div className={style.description}>{title}</div>
                    </div>
                    {cta?.link?.url && (
                        <div className={style.caseStudyCta}>
                            <SmartLink href={cta.link.url} target={cta.link.target ? cta.link.target : ''} hasArrow>
                                {cta.text}
                            </SmartLink>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
};

const AcceptTermsPageContent = ({ acceptedTermsPageContent, currentUrl }) => {
    const { headingText, subHeading, body, image, quoteCarousel, downloadHeading, downloadDescription, contents, relatedCaseStudiesHeading, relatedCaseStudiesDescription, relatedCaseStudies } = acceptedTermsPageContent;
    const sliderParams = {
        slidesToShow: 1,
        arrows: false,
        infinite: false,
        speed: 700,
        draggable: true,
        swipe: true,
    };

    const renderCard = (data, index) => {
        return (
            <div key={index} className={style.reportCard}>
                <CaseStudyCard {...data} />
            </div>
        );
    };
    const sliderBreakpoints = [
        {
            breakpoint: 9999,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ];
    const sliderBreakpoints2 = [
        {
            breakpoint: 9999,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
            },
        },
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
            },
        },
    ]
    const wSize = useWindowSize();
    let renderSingleCard = false;
    if (wSize && wSize[0] < 1200) {
        renderSingleCard = true;
    }
    return (
        <div className={style.el}>
            <div className={style.headerSection}>
                <div className={style.leftColumn}>
                    {headingText && <h1 className={style.heading}>{headingText}</h1>}
                    {subHeading && <h2 className={style.subHeading}>{subHeading}</h2>}
                    {quoteCarousel?.quotes && (
                        <div className={style.quoteSection}>
                            <QuoteCarousel
                                quotes={quoteCarousel.quotes}
                                currentUrl={currentUrl}
                                headline={headingText}
                            />
                        </div>
                    )}
                </div>
                <div className={style.rightColumn}>
                    {image && <ImageItem image={image.image} />}
                    <div className={style['article-text']}>
                        {body && (
                            <div dangerouslySetInnerHTML={{ __html: body }} />
                        )}
                    </div>
                </div>
            </div>
            {relatedCaseStudies && relatedCaseStudies.length > 0 && (
                <div className={style.caseStudySection}>
                    {relatedCaseStudiesHeading && (
                        <div className={style.caseStudyHeading}>
                            <h2>{relatedCaseStudiesHeading}</h2>
                        </div>
                    )}
                    {relatedCaseStudiesDescription && (
                        <div className={style.caseStudyDescription}>{relatedCaseStudiesDescription}</div>
                    )}
                    {renderSingleCard && (
                        <CarouselStandardNews className={style.carouselOverrides} sliderParams={sliderParams} sliderBreakpoints={sliderBreakpoints}>
                            {relatedCaseStudies.map((item, i) => <Fragment key={i}>{renderCard(item, i)}</Fragment>)}
                        </CarouselStandardNews>
                    )}
                    {!renderSingleCard && (
                        <CarouselStandardNews className={style.carouselOverrides} sliderParams={sliderParams} sliderBreakpoints={sliderBreakpoints2}>
                            {relatedCaseStudies.map((item, i) => <Fragment key={i}>{renderCard(item, i)}</Fragment>)}
                        </CarouselStandardNews>
                    )}
                </div>
            )}

            {contents && contents.length > 0 && (
                <Fragment>
                    {downloadHeading && (
                        <div className={style.downloadHeading}>
                            <h2>{downloadHeading}</h2>
                        </div>
                    )}
                    {downloadDescription && (
                        <div className={style.downloadDescription}>{downloadDescription}</div>
                    )}
                    <div className={style.downloadSection}>
                        {contents.map((item, i) => {
                            if (item.type === 'newsDetailDownload') {
                                return (
                                    <div key={i} className={style.downloadItem}>
                                        <DownloadCard {...item} />
                                    </div>
                                );
                            } else if (item.type === 'newsDetailDownloadContent') {
                                return (
                                    <div key={i} className={style.downloadItem}>
                                        <DownloadCardContent {...item} />
                                    </div>
                                );
                            }
                            return null;
                        })}
                    </div>
                </Fragment>
            )}
        </div>
    );
};
CaseStudyCard.propTypes = {
    title: PropTypes.string,
    cta: PropTypes.object,
    image: PropTypes.object,
    publishingDate: PropTypes.string,
    type: PropTypes.string
};

AcceptTermsPageContent.propTypes = {
    acceptedTermsPageContent: PropTypes.object.isRequired,
    currentUrl: PropTypes.string,
};

export default AcceptTermsPageContent;
